const Home = () => import('@/views/dash/settings/library/LibraryHome.vue')
const File = () => import('@/views/dash/settings/library/LibraryFile.vue')

export default [

    {
        path: 'biblioteca',
        name: 'library.home',
        component: Home,
        meta: { title: 'Bliblioteca', permission: 2 },
        children: [
            { path: '', name: 'library.all', component: File, meta: { title: 'Meus arquivos' } },
            { path: 'audio', name: 'library.audio', component: File, meta: { title: 'Audio' } },
            { path: 'documento', name: 'library.document', component: File, meta: { title: 'Documento' } },
            { path: 'video', name: 'library.video', component: File, meta: { title: 'Video' } },
            { path: 'imagem', name: 'library.image', component: File, meta: { title: 'Imagens' } },
        ],
    },
]